import { render, staticRenderFns } from "./MyCooks.vue?vue&type=template&id=55eab923&scoped=true&"
import script from "./MyCooks.vue?vue&type=script&lang=js&"
export * from "./MyCooks.vue?vue&type=script&lang=js&"
import style0 from "./MyCooks.vue?vue&type=style&index=0&id=55eab923&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55eab923",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VFlex,VLayout})
